import http from "./http";
import type { Permiso } from "../models/permiso_model";

export const createPermiso = async (data: Permiso) => {
  try {
    return await http.post<Permiso, Permiso>(`/kinder/permiso/`, data);
  } catch (error) {
    console.error("[create] Error :: ", error);
    return null;
  }
};